<template>
  <div>
    <el-row>
      <TableContainer
        CustomTableArticle
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"
        :tableToolConfig="tableToolConfig"
        ref="TableContainer"
      >
        <template v-slot:tools>
          <router-link :to="containerBaseUrl + '/add'">
            <el-button type="primary" icon="el-icon-circle-plus-outline">增加学习班</el-button>
          </router-link>
        </template>

        <template v-slot:filter>
          <!-- <selectTableFilterStatus
            @DoChange="DoChangeStatus"
            showReview
            showDraft
            ref="selectTableFilterStatusRef"
          ></selectTableFilterStatus>-->
        </template>

        <!--  -->
        <template v-slot:table__footer__info>学习班列表</template>
      </TableContainer>

      <!-- <el-row>
          <p class="paragraph-content-small grey asset"><i class="el-icon-info"></i> 当前列表项的显示顺序，即是网站相关项目的显示顺序。</p>
      </el-row>-->
    </el-row>
  </div>
</template>



<script>
import { BaseVue } from "@/mixin/index";
import { TableContainer } from "@/core/table/";

export default {
  name: "StudyClass",
  
  mixins: [BaseVue],
  
  components: {
    TableContainer
  },
  
  data() {
    return {
      // 基础地址
      containerBaseUrl: "/studyclass",
      // api的基础地址
      containerServerUrl: "/api/manager/studyclass",
      // table config 设置
      tableToolConfig: {
        canEdit: true,
        canRecover: true,
        canDelete: true,
        canDisable: true
      }
    };
  },
  
  computed: {
    containerTableColumns() {
      if (this.isAdmin || this.isSystemManager) {
        return [
          {
            prop: "title",
            label: "名称"
          },
          {
            prop: "studyclasstypename",
            label: "所属类型",
            width: "200px"
          },
          {
            prop: "typestr",
            label: "类型",
            width: "100px"
          },
          {
            prop: "classunitname",
            label: "开班单位",
            width: "200px"
          }
        ];
      } else if (this.isUnitManager) {
        return [
          {
            prop: "title",
            label: "名称"
          },
          {
            prop: "studyclasstypename",
            label: "所属类型",
            width: "200px"
          },
          {
            prop: "typestr",
            label: "类型",
            width: "100px"
          },
          {
            prop: "classunitname",
            label: "开班单位",
            width: "200px"
          }
        ];
      } else if (this.isPartyManager) {
        return [
          {
            prop: "title",
            label: "名称"
          },
          {
            prop: "typestr",
            label: "类型",
            width: "100px"
          },
          {
            prop: "classunitname",
            label: "开班组织",
            width: "200px"
          }
        ];
      }
      
      // 如果没有匹配的条件，返回空数组
      return [];
    }
  },
  
  mounted() {
    // 组件挂载后的逻辑
  }
};
</script>
<style scoped>
</style>